import { defineComponent } from 'vue';
import componentI18n from '@/i18n/componentI18n';
export default defineComponent({
    ...componentI18n('components.need_help')
});
